import { render } from "./showCard.vue?vue&type=template&id=5850f83c"
import script from "./showCard.vue?vue&type=script&lang=js"
export * from "./showCard.vue?vue&type=script&lang=js"

import "./showCard.vue?vue&type=style&index=0&id=5850f83c&scope=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__